import React from 'react'

import { CircularProgress, Typography, styled } from '@mui/material';
import ModalConfirmButton from './ModalMessages/ModalConfirmButton';
import ModalCancelButton from './ModalMessages/ModalCancelButton';
const CustomErrorTypography = styled(Typography)(({ theme }) => ({
	fontSize: '14px',
	color: '#F74646',
    fontFamily:'Figtree-regular',
	marginBottom: '30px',
	textAlign:'center',
	marginTop:'-35px',
	marginRight:'15px'
}));

const DeleteAccountModal = ({onConfirmFn, onCloseFn, showDeleteSpinner}) => {
  return (
    <>
        <CustomErrorTypography >
            This action cannot be undone
        </CustomErrorTypography>

        <div className='modal-buttons-container'>
            <ModalCancelButton 
                custompadding="5px 35px"
                onClickFn={onCloseFn}
                label='No'
                 className='!text-size-13'
                customWidth={200}
                customisedFontSize={"16px"}
            />

              <ModalConfirmButton
                  custompadding="5px 35px"
                  customBgColor={"#F74646"}
                  className='!text-size-13'
                  // label='Yes'
                  label={
                      showDeleteSpinner ? (
                          <CircularProgress size='2vh' thickness={5} color='inherit' />
                      ) : (
                          "Yes"
                      )
                  }
                  onClickFn={onConfirmFn}
                  customWidth={200}
                  customisedFontSize={"16px"}
                  disabled={showDeleteSpinner}
              />
        </div>
    </>
    )
}

export default DeleteAccountModal